<template>
    <div class="grid grid-cols-12 gap-4 lg:gap-6">
        <aside class="col-span-full lg:col-span-4">
            <PageNavigation v-bind="navigation" />
        </aside>
        <div class="col-span-full grid lg:col-span-8">
            <template v-for="component in sections" :key="component.id">
                <component
                    :is="AccordionBlock"
                    v-bind="{ ...component, items: (component as FaqSection).items ?? [] }"
                    :id="component.id" />
            </template>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { FaqSection, FaqSectionsComponentModel } from '@su4r-frontend/api';
import AccordionBlock from '../accordion/AccordionBlock.vue';

const { sections } = defineProps<FaqSectionsComponentModel>();
</script>
